export const groupBy = (xs: any, key: string) => xs.reduce((rv: any, x: any) => {
  (rv[x[key]] = rv[x[key]] || []).push(x);
  return rv;
}, {})
